export default __webpack_public_path__ + "static/media/yate.b1c9722f.png";